import React, { useEffect, useRef } from 'react';
import { StyledChildrenContainer, StyledDialog, StyledIconButton, StyledInner } from './index.styles.js';
export const Dialog = ({ children, padding = true, open, triggerButton, variant, dialogAriaProps, onCloseButtonAriaLabel, onCloseButtonClick, onClose, 'data-testid': dataTestId, className, role }) => {
    const dialogRef = useRef(null);
    // TODO: Remove handleClose and replace it with the onClose prop once onCloseButtonClick has been removed
    const handleClose = () => {
        if (onCloseButtonClick) {
            onCloseButtonClick();
        }
        if (onClose) {
            onClose();
        }
    };
    useEffect(() => {
        const element = dialogRef.current;
        if (!element)
            return;
        element.addEventListener('cancel', handleClose);
        if (open) {
            element.showModal();
        }
        else {
            element.close();
        }
        return () => {
            element.removeEventListener('cancel', handleClose);
        };
    }, [open]);
    return (React.createElement(React.Fragment, null,
        triggerButton,
        React.createElement(StyledDialog, { ref: dialogRef, "aria-describedby": dialogAriaProps?.ariaDescribedBy, "aria-labelledby": dialogAriaProps?.ariaLabelledBy, variant: variant, hasPadding: padding, "data-testid": dataTestId, className: className, role: role }, variant === 'alert' ? (children) : (React.createElement(StyledInner, null,
            React.createElement(StyledIconButton, { hasPadding: padding, "aria-label": onCloseButtonAriaLabel, variant: "tertiary", icon: "cancel", onClick: handleClose, size: "sm" }),
            React.createElement(StyledChildrenContainer, null, children))))));
};
Dialog.displayName = 'Dialog';
//# sourceMappingURL=index.js.map